import React from "react";
import Contact from "./components/Contact";
import DownloadSection from "./components/DownloadSection";
import Features from "./components/Features";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ListingSharePage from "./components/ListingSharePage";
import ScreenshotGallery from "./components/ScreenshotGallery";
import "./styles/global.css";

/** Ex. /listing/abc123 — liens partagés depuis l’app */
export function parseListingIdFromPath(pathname) {
  const m = String(pathname).match(/^\/listing\/([^/]+)\/?$/);
  return m ? decodeURIComponent(m[1]) : null;
}

function App() {
  const listingId = parseListingIdFromPath(window.location.pathname);

  if (listingId) {
    return <ListingSharePage listingId={listingId} />;
  }

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Features />
        <ScreenshotGallery />
        <DownloadSection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
